module.exports = __webpack_public_path__ + "static/media/Art_of_numbers_qr_code.a9d8594d.jpg";